module.exports = __webpack_public_path__ + "img/honey-dijon-mustard-dressing.008a5f3a.jpg";